namespace Matrix.Data {

    @Serenity.Decorators.panel()
    export class SecurityRepairLogPanel extends Serenity.TemplatedDialog<any> {


        constructor() {
            super();

            new SecurityRepairLogGrid(this.byId("Grid")).setTitle(null);
            this.dialogTitle = "Security Repair Log";

            $(window).on('resize.' + this.uniqueName, () => this.arrange());
        }

        destroy() {
            $(window).off('.' + this.uniqueName);

            super.destroy();
        }

        protected arrange() {
            super.arrange();

            this.byId('Grid').css('height', Math.max(150, window.innerHeight - 180) + 'px');
        }

        protected getTemplate() {
            return `<div id="~_Grid"></div>`;
        }
    }
}